import PolicyUserModelBase from './lib/odd-policy_user_model';
export default PolicyUserModelBase;